"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _PanelHeaderWithIcon = require("@insided/deprecated-control/ui-components/PanelHeaderWithIcon");

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _interfaces = require("@insided/deprecated-control/EmailCampaigns/interfaces");

var _Message = require("@insided/deprecated-control/ui-components/Message");

var _classnames = _interopRequireDefault(require("classnames"));

function getChooseEmailTypePanel(props) {
  var isEditEnabled = props.isEditEnabled,
      status = props.status,
      campaignType = props.campaignType,
      selectedCampaignType = props.selectedCampaignType,
      accordionActivePanel = props.accordionActivePanel,
      onEmailTypeChanged = props.onEmailTypeChanged,
      onClickPanelCallback = props.onClickPanelCallback;
  var metaTextMappingForChooseEmailType = {
    'one-off': 'One off email',
    scheduled: 'Scheduled one off email',
    automated: 'Automated email'
  };
  var valueMappingForChooseEmailType = {
    'one-off': 'one-off',
    scheduled: 'one-off',
    automated: 'automated'
  };
  var hideMetaText = isEditEnabled && accordionActivePanel === _interfaces.CHOOSE_EMAIL_TYPE_INDEX;
  var mappedMetaText = campaignType ? metaTextMappingForChooseEmailType[campaignType] : undefined;
  var metaText = hideMetaText ? undefined : mappedMetaText;
  var isDone = campaignType !== undefined;
  var disableEditOfEmailType = status !== 'draft';
  return {
    onClick: function onClick() {
      return onClickPanelCallback();
    },
    title: (0, _preact.h)(_PanelHeaderWithIcon.PanelHeaderWithIcon, {
      customClass: "panel-header-container",
      iconCustomClass: "icon-panel-header",
      icon: "customisation",
      title: "Choose email type",
      meta: metaText,
      isDone: isDone && isEditEnabled
    }),
    body: isEditEnabled ? (0, _preact.h)("div", {
      className: "email-type-selection-container"
    }, (0, _preact.h)("div", {
      className: "email-type-option-container"
    }, (0, _preact.h)(EmailTypeOption, {
      title: "Send one-off email",
      description: "Send out a one-off email to users who match the criteria now, or at the scheduled time.",
      icon: "oneOffEmail",
      value: "one-off",
      campaignType: selectedCampaignType ? valueMappingForChooseEmailType[selectedCampaignType] : '',
      disableEdit: disableEditOfEmailType,
      onClick: onEmailTypeChanged
    }), (0, _preact.h)(EmailTypeOption, {
      title: "Set as an automated email",
      description: "Send out this email to users once they match the criteria for this campaign.",
      icon: "automatedEmail",
      value: "automated",
      campaignType: selectedCampaignType ? valueMappingForChooseEmailType[selectedCampaignType] : '',
      disableEdit: disableEditOfEmailType,
      onClick: onEmailTypeChanged
    })), (0, _preact.h)(_Message.Message, {
      text: "Email type cannot be changed once the campaign is published.",
      variant: "info"
    })) : null,
    customClass: 'panel-email-campaign-type-selection',
    collapsible: isEditEnabled
  };
}

var EmailTypeOption = function EmailTypeOption(_ref) {
  var title = _ref.title,
      description = _ref.description,
      icon = _ref.icon,
      value = _ref.value,
      campaignType = _ref.campaignType,
      _onClick = _ref.onClick,
      disableEdit = _ref.disableEdit;
  var isSelected = campaignType === value;
  var disableOption = campaignType !== value && disableEdit;
  var customClassNames = (0, _classnames.default)('email-type-option', {
    'selected-email-type': isSelected,
    'disable-edit': disableOption
  });
  var iconColor = disableOption ? '#9599A2' : '#0069FF';
  return (0, _preact.h)("div", {
    className: customClassNames,
    onClick: function onClick() {
      if (disableOption) {
        return;
      }

      _onClick(value);
    }
  }, (0, _preact.h)(_assets.default, {
    customClass: "email-type-option-icon ".concat(value, "-email-icon"),
    icon: icon,
    color: iconColor
  }), (0, _preact.h)("div", {
    className: "email-type-option-title"
  }, title), (0, _preact.h)("div", {
    className: "email-type-option-description"
  }, description));
};

var _default = getChooseEmailTypePanel;
exports.default = _default;